import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './style/fonts.scss'
import './style/globol.scss'
import vuetify from './plugins/vuetify.js'
import excel from 'vue-excel-export'

Vue.use(excel)
// import Multiselect from 'vue-multiselect';

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  store,
  // Multiselect,
  render: h => h(App)
}).$mount('#app')
